import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationMain } from '../styles/common';
import CheckIcon from '@material-ui/icons/Check';
import PlayArrowIcon from '@material-ui/icons/PlayArrowOutlined';
import { userRegionalAdminDashboard } from 'src/actions/action.userDashboard';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { DataCollectorDashboardWrapper } from '../styles/datacollectordashboard';
import { Grid, Typography, Button, FormControl, Select, MenuItem, Switch, FormControlLabel, IconButton } from '@material-ui/core';
import EmailIcon from '@material-ui/icons/Email';
import FeaturedVideoIcon from '@material-ui/icons/FeaturedVideo';
import CoverageComponent from '../components/surveys/dashboard/Coverage';
import ForecastComponent from '../components/surveys/dashboard/Forecast';
import Input from '@material-ui/core/Input';
import { Link } from 'react-router-dom';
import LoaderComponent from 'src/components/common/loader.component';
import { getLocalStorageValue, setLocalStorageValue, clearLocalStorageValueForKey } from 'src/effects/utils/local-storage';
// import * as moment from 'moment';
import { getCountriesAssignedToUser, syncOfflineResponse, setSurveyOfflineModeAction, syncOfflineCompleted, setSurveyResponseOffline } from '../actions/action.module';
import { updateCurrentActiveCountryCall, getSurveyResponseCall } from 'src/effects/api/api.module';
import { userDashboard, userDashboardOffline } from 'src/actions/action.userDashboard';
import { Link as MatLink } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { DATACOLLECTOR_DASHBOARD_KEY, DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY, DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY, SYNC_SURVEY_GET_USER_COUNTRIES_KEY } from 'src/constants/constants';
import { setLoaderVisibility } from 'src/actions/action.common';
import { ModuleSubmissionStatusEnum, ModuleType } from 'src/constants/Enum/ModuleEnum';
import { NO_INTERNET_CONNECTIVITY, OFFLINE_DEACTIVATION_CONFIRAMATION } from 'src/constants/NotificationMessageConstant';
import { ShowCustomError } from 'src/effects/utils/tostar';
import ConfirmationComponent from 'src/components/common//notification/ConfirmationComponent';
import { push } from 'connected-react-router';
import { getCurrentUrl } from 'src/effects/utils/common';


class DataCollectorResponseContainer extends React.Component<any, any> {
    state = {
        spacing: '16',
        countryId: 0,
        isOfflineMode: false,
        isConfirmDialogShow: false,
        offlineStoredUserCount: 0,
        isDashboard: true,
        selectedSurveyId: 0
    };
    constructor(props: any) {
        super(props);

        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.getSelectedCountry = this.getSelectedCountry.bind(this);
        this.handleOfflineModeChange = this.handleOfflineModeChange.bind(this);
        this.handleSyncOfflineData = this.handleSyncOfflineData.bind(this);
        this.handleDialogDeactivateOfflineMode = this.handleDialogDeactivateOfflineMode.bind(this);
        this.onCloseConfirmation = this.onCloseConfirmation.bind(this);
        this.gotoResponses = this.gotoResponses.bind(this);
    }

    componentDidMount() {
        getCurrentUrl().then((currUrl: any) => {
            const splitUrl = currUrl.split("/");
            const surveyId: any = parseInt(splitUrl[4], 10);
            this.props.userRegionalAdminDashboard({ surveyId, isDashboard: true });
            this.setState({ isAdmin: false, selectedSurveyId: surveyId });
        });

        const loggedInUser = getLocalStorageValue('user');
        const isOfflineMode = getLocalStorageValue(`UserId_${loggedInUser.id}_${DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY}`);
        if (isOfflineMode === true) {
            this.setState({ isOfflineMode: true });
        }

        this.setOfflineStoredUserCount(loggedInUser);
        this.props.getCountriesAssignedToUser();
    }

    setOfflineStoredUserCount(loggedInUser: any) {
        let offlineStoredUserCount = 0;
        for (const key in localStorage) {
            if (key.indexOf(DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY) !== -1) {
                if (key.indexOf(loggedInUser.id) === -1) {
                    offlineStoredUserCount++;
                }
            }
        }
        this.setState({ offlineStoredUserCount });
    }

    gotoResponses(isDashboard: any) {
        this.setState({
            isDashboard
        });

        this.props.redirectTo('/data-collector-dashboard/' + this.state.selectedSurveyId)
    }

    onCloseConfirmation() {
        this.setState({
            isConfirmDialogShow: false
        });
    }

    handleOfflineModeChange() {
        this.props.showLoaderVisibility();
        const localStorageuserData = getLocalStorageValue('user');
        const userId = localStorageuserData.id;

        if (this.state.isOfflineMode) {
            this.setState({ isConfirmDialogShow: true });
            this.props.hideLoaderVisibility();
        }
        else {

            for (const key in localStorage) {
                if (key.indexOf(`UserId_${userId}_${DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY}`) !== -1) {
                    clearLocalStorageValueForKey(key);
                }
            }

            setLocalStorageValue(`UserId_${userId}_${DATACOLLECTOR_DASHBOARD_KEY}`, JSON.stringify(this.props.data));
            setLocalStorageValue(`UserId_${userId}_${DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY}`, 'true');

            const moduleTypes: any = this.props.data.payload.module_types;
            const promises: any = [];

            for (let moduleIndex = 1; moduleIndex <= 3; moduleIndex++) {
                if (moduleIndex === ModuleType.Coverage && moduleTypes[moduleIndex - 1] && moduleTypes[moduleIndex - 1].categories) {
                    moduleTypes[moduleIndex - 1].categories.forEach((category: any) => {
                        if (category && category.modules && category.modules.length > 0) {
                            category.modules.forEach((module: any) => {
                                if (module.is_enabled) {
                                    const moduleOfflineData = getLocalStorageValue(`UserId_${userId}_${DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY}_${module.country_module_survey_mapping_id}`);
                                    if (!moduleOfflineData) {
                                        const data = { payload: { countryModuleSurveyMappingId: module.country_module_survey_mapping_id } };
                                        promises.push(Promise.resolve(getSurveyResponseCall(data).then((res: any) => {
                                            setLocalStorageValue(`UserId_${userId}_${DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY}_${module.country_module_survey_mapping_id}`, JSON.stringify(res));
                                        })));
                                    }
                                }
                            });
                        }
                    });
                }
                else if (moduleIndex === ModuleType.Forecast) {
                    if (moduleTypes[moduleIndex - 1] && moduleTypes[moduleIndex - 1].modules && moduleTypes[moduleIndex - 1].modules.length > 0) {
                        moduleTypes[moduleIndex - 1].modules.forEach((module: any) => {
                            if (module.is_enabled) {
                                const moduleOfflineData = getLocalStorageValue(`UserId_${userId}_${DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY}_${module.country_module_survey_mapping_id}`);
                                if (!moduleOfflineData) {
                                    const data = { payload: { countryModuleSurveyMappingId: module.country_module_survey_mapping_id } };
                                    promises.push(Promise.resolve(getSurveyResponseCall(data).then((res: any) => {
                                        setLocalStorageValue(`UserId_${userId}_${DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY}_${module.country_module_survey_mapping_id}`, JSON.stringify(res));
                                    })));
                                }
                            }
                        });
                    }
                }
            }

            Promise.all(promises).then().then(data => {
                this.props.hideLoaderVisibility();
                this.setState({ isOfflineMode: !this.state.isOfflineMode });
                this.props.setSurveyOfflineMode(!this.state.isOfflineMode);
            });
        }
    }

    handleDialogDeactivateOfflineMode() {
        this.setState({ isOfflineMode: false, isConfirmDialogShow: false });
        this.props.setSurveyOfflineMode(false);
        const localStorageuserData = getLocalStorageValue('user');
        const userId = localStorageuserData.id;

        for (const key in localStorage) {
            if (key.indexOf(`UserId_${userId}_${DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY}`) !== -1) {
                clearLocalStorageValueForKey(key);
            }
        }

        if (this.state.isOfflineMode) {
            clearLocalStorageValueForKey(`UserId_${userId}_${DATACOLLECTOR_DASHBOARD_KEY}`);
            clearLocalStorageValueForKey(`UserId_${userId}_${DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY}`);
            clearLocalStorageValueForKey(`UserId_${userId}_${SYNC_SURVEY_GET_USER_COUNTRIES_KEY}`);
            this.props.getCountriesAssignedToUser();
        }

        this.props.hideLoaderVisibility();
    }

    handleSyncOfflineData() {
        this.setState({ isOfflineMode: false, isConfirmDialogShow: false });
        if (navigator.onLine) {
            const dataList = [];
            for (const key in localStorage) {
                if (key.indexOf(DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY) !== -1) {
                    const countryModuleSurveyMappingId = parseInt(key.split('_')[key.split('_').length - 1], 10);
                    const data = getLocalStorageValue(key);
                    const localStorageuserData = getLocalStorageValue('user');
                    const userId = localStorageuserData.id;

                    for (const pageData of data.data.payload.module_pages) {
                        for (const cluster of pageData.page.question_clusters) {
                            for (const question of cluster.questions) {
                                if (question.is_response_offline_filled) {
                                    dataList.push({
                                        id: 0,
                                        question_id: question.id,
                                        country_module_survey_mapping_id: countryModuleSurveyMappingId,
                                        user_id: userId,
                                        question_type: question.input_type,
                                        question_responses: question.question_responses,
                                        question_admin_responses: question.question_admin_responses,
                                        question_comments: question.question_comments.reverse()
                                    });
                                }
                            }
                        }
                    }
                }
            }

            this.props.syncOfflineResponse(dataList);
        }
        else {
            ShowCustomError(NO_INTERNET_CONNECTIVITY);
        }
    }


    handleCountryChange = (event: any) => {
        if (event.target.value && event.target.value > 0) {
            this.setState({ countryId: event.target.value });
            updateCurrentActiveCountryCall(event.target.value);
            const data = {
                'countryId': event.target.value,
                'surveyId': this.state.selectedSurveyId
            }

            this.props.dashboard(data);
        }
    }

    getSelectedCountry() {
        let selectedCountry: any;
        const state: any = this.state;
        const countryId: any = parseInt(state.countryId, 10);
        if (this.props.countryData.countries.length > 0) {
            selectedCountry = this.props.countryData.countries.find((val: any) => val.id === countryId);
        }

        return selectedCountry ? selectedCountry.name : '';
    }

    getSurveyPercentage(data: any) {
        let percentageTotal = 0;
        let moduleCount = 0;
        if (data) {
            if (data.module_types) {
                for (let mtIndex = 0; mtIndex < data.module_types.length; mtIndex++) {
                    if ((mtIndex === 0 || mtIndex === 2) && data.module_types[mtIndex].modules) {
                        for (const module of data.module_types[mtIndex].modules) {
                            percentageTotal += parseInt(module.percentage_completed, 10);
                            moduleCount++;
                        }
                    }

                    if (mtIndex === 1 && data.module_types[mtIndex].categories) {
                        for (const category of data.module_types[mtIndex].categories) {
                            if (category.modules) {
                                for (const catModule of category.modules) {
                                    percentageTotal += parseInt(catModule.percentage_completed, 10);
                                    moduleCount++;
                                }
                            }
                        }
                    }
                }
            }
        }

        return moduleCount === 0 ? 0 : Math.round(percentageTotal / moduleCount);
    }

    UNSAFE_componentWillReceiveProps(props: any) {
        const loggedInUser = getLocalStorageValue('user');

        if (props.countryData && props.countryData.active_country_id && this.state.countryId !== props.countryData.active_country_id && this.state.selectedSurveyId > 0) {
            if (this.state.countryId === 0) {
                this.setState({ countryId: props.countryData.active_country_id });
                const isOfflineMode = getLocalStorageValue(`UserId_${loggedInUser.id}_${DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY}`);
                if (isOfflineMode === true) {
                    this.setState({ isOfflineMode: true });
                    this.props.offlineDashboard();
                }
                else {
                    const data = {
                        'countryId': props.countryData.active_country_id,
                        'surveyId': this.state.selectedSurveyId
                    }
                    this.props.dashboard(data);
                }
            }
        }

        if (this.props.syncOffline === true || this.props.syncOffline === null && this.state.selectedSurveyId > 0) {
            if (!this.state.isOfflineMode) {
                this.setState({ isOfflineMode: !this.state.isOfflineMode })

                this.props.syncOfflineCompleted();
                const data = {
                    'countryId': props.countryData && props.countryData.active_country_id ? props.countryData.active_country_id : 0,
                    'surveyId': this.state.selectedSurveyId
                }
                this.props.dashboard(data);
            }
        }

        this.setOfflineStoredUserCount(loggedInUser);

        if (props && ((props.adminDashboard && (Object.keys(props.adminDashboard).length > 0)) || (props.regionalDashboard && Object.keys(props.regionalDashboard).length > 0))) {
            this.setState({
                dashobardData: props.regionalDashboard
            })
        }

        if (props && props.surveys && props.surveys.length > 0) {
            const surveys: any = props.surveys ? props.surveys.filter((item: any) => (item.statusText !== "Draft" && item.id === this.state.selectedSurveyId)) : [];
            this.setState({
                surveys,
                selectedSurvey: surveys[0]
            })
        }
    }

    render() {
        const data = this.props.data && this.props.data.payload;
        const surveyCompletionPercentage = this.getSurveyPercentage(data);
        const user = getLocalStorageValue('user');
        let giModule: any;
        if (data && data.module_types.length && data.module_types[0] && data.module_types[0].modules[0] && data.module_types[0].modules[0]) {
            giModule = data.module_types[0].modules[0];
        }
        const surveyStatus = data && data.survey_status
        const isdisplaySurveyButton = data && data.module_types.length && data.module_types[0] && data.module_types[0].modules[0] && !this.state.isOfflineMode

        return (
            <ApplicationMain>
                <LoaderComponent sending={this.props.show} />
                <ConfirmationComponent handleDialogSubmit={this.handleDialogDeactivateOfflineMode} message={OFFLINE_DEACTIVATION_CONFIRAMATION} open={this.state.isConfirmDialogShow} />

                <DataCollectorDashboardWrapper>
                    <div className="pageContainer dataDashboardScreen">
                        <div className="pageHeading">
                            <Grid container={true} spacing={8}>
                                <Grid item={true} xs={6}>
                                    <div className="pageTitleSection">
                                        <Typography component="h2" variant="title" align="left" gutterBottom={true} className="pageTitle">
                                            Welcome, {user ? user.firstName + ' ' + user.lastName : ''}
                                        </Typography>
                                    </div>
                                </Grid>

                                <Grid item={true} xs={6}>
                                    {
                                        this.state && this.state.selectedSurveyId > 0 ?
                                            <div className="pagesLinks text-right">
                                                <ul>
                                                    {
                                                        this.state.offlineStoredUserCount < 2
                                                            ?
                                                            <>
                                                                {
                                                                    this.state.isOfflineMode
                                                                        ?
                                                                        <li className="listItem">
                                                                            <Button type="button" className="btn-blue-primary"
                                                                                variant="outlined" size="medium" onClick={this.handleSyncOfflineData}>
                                                                                Sync Offline Data <ChevronRightIcon className="ChevronRightIcon" />
                                                                            </Button>
                                                                        </li>
                                                                        :
                                                                        ''
                                                                }
                                                                {
                                                                    surveyStatus !== 3 &&
                                                                    <li className="listItem">
                                                                        <FormControlLabel
                                                                            value="start"
                                                                            control={<Switch
                                                                                checked={this.state.isOfflineMode}
                                                                                onChange={this.handleOfflineModeChange}
                                                                                value="checkedB"
                                                                                color="primary"
                                                                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                                                            />}
                                                                            label="Activate Offline Mode"
                                                                            labelPlacement="start"
                                                                        />
                                                                    </li>
                                                                }
                                                            </>
                                                            :
                                                            <li className="listItem"><div className="submitSurveyDisclaimer">Limit Reached! Maximum 2 users can only activate offline mode at a time.</div></li>
                                                    }
                                                    <li className="listItem">
                                                        <span className="changeCountry">Change Country</span>
                                                    </li>
                                                    <li className="listItem">
                                                        <FormControl fullWidth={false}>
                                                            <Select
                                                                value={this.state.countryId}
                                                                onChange={this.handleCountryChange}
                                                                input={<Input name="country" id="age-auto-width" />}
                                                                autoWidth={false}
                                                                id="countryList"
                                                                disabled={this.state.isOfflineMode}
                                                            >
                                                                <MenuItem key={0} value={0}>Select</MenuItem>
                                                                {
                                                                    this.props.countryData && this.props.countryData.countries ?
                                                                        this.props.countryData.countries.map((mt: any) => {
                                                                            return (
                                                                                <MenuItem key={mt.id} value={mt.id}>{mt.name}</MenuItem>
                                                                            )
                                                                        })
                                                                        :
                                                                        ''
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    </li>
                                                </ul>
                                            </div>
                                            :
                                            <></>
                                    }
                                </Grid>
                            </Grid>

                            {
                                this.state && this.state.selectedSurveyId > 0 ?
                                    <Grid container={true} spacing={8}>
                                        <Grid item={true} xs={6}>
                                            <div className="pageTitleSection">
                                                <IconButton className="backButton" color="inherit" aria-label="Open drawer" onClick={this.gotoResponses}>
                                                    <KeyboardBackspaceIcon />
                                                </IconButton>
                                                <Typography component="h2" variant="title" align="left" gutterBottom={true} className="pageTitle strongText">
                                                    {data ? (data.survey_name ? data.survey_name : '') : ''}&nbsp;{data ? (data.survey_year ? data.survey_year : '') : ''}
                                                </Typography>
                                                <Typography className="headingLink">
                                                    {
                                                        surveyStatus !== 3 &&
                                                        <span>
                                                            ( {surveyCompletionPercentage ? surveyCompletionPercentage : '0'}% complete )
                                                        </span>
                                                    }
                                                </Typography>
                                            </div>
                                        </Grid>
                                        {
                                            surveyStatus !== 3 &&
                                            <Grid item={true} xs={6}>
                                                <div className="text-right">
                                                    <FormControl fullWidth={false}>
                                                        {/* <div className="box-red">
                                                            Deadline: {data ? (data.survey_deadline ? moment(data.survey_deadline).format("DD-MM-YYYY") : '') : ''}
                                                        </div> */}
                                                    </FormControl>
                                                </div>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    ''
                            }

                        </div>
                        <div className="pageContent">
                            {
                                data && data.module_types && data.module_types.length > 0 ?
                                    <>
                                        <div className={surveyStatus === 3 ? "contentClosedSection" : "contentSection"}>
                                            {
                                                data && data.survey_id > 0 ?
                                                    <Grid container={true} spacing={24}>
                                                        <Grid item={true} xs={12}>
                                                            <div className="media-list-wrapper">
                                                                {
                                                                    data && data.is_GI_Applicable && data.module_types[0].type === 'General Information' &&
                                                                    <div className="media-list">
                                                                        <div className="media-content">
                                                                            <div className={giModule && giModule.module_status === ModuleSubmissionStatusEnum.Completed ? "media-left media-box media-box-success media-box-large" : "media-left media-box media-box-primary media-box-large"}>
                                                                                {giModule && giModule.module_status === ModuleSubmissionStatusEnum.Completed ? <CheckIcon fontSize="large" /> : <PlayArrowIcon fontSize="large" />}
                                                                            </div>
                                                                            <div className="media-body">
                                                                                <Typography variant="caption" className="captionText">
                                                                                    Step 1:
                                                                            </Typography>
                                                                                <h5 className="mt-0">{data && data.module_types[0] && data.module_types[0].type}</h5>
                                                                                <p>{data && data.module_types[0] ? 'Collecting data for 2019 programme coverage' : ''}</p>

                                                                                <div className="progress">
                                                                                    <div className={giModule && giModule.module_status === ModuleSubmissionStatusEnum.Completed ? "progress-bar progress-bar-success" : "progress-bar progress-bar-primary"} style={{ width: (giModule ? giModule.percentage_completed : 0) + '%' }} role="progressbar">
                                                                                        &nbsp;
                                                                            </div>
                                                                                </div>
                                                                                <p className="smallText">{giModule && giModule.module_description}</p>
                                                                            </div>
                                                                            <div className="media-right">
                                                                                <div className="text-right">
                                                                                    {
                                                                                        isdisplaySurveyButton ?
                                                                                            <Link to={`/survey/response/${data.module_types[0].modules[0].country_module_survey_mapping_id}`} >
                                                                                                <Button type="button" className="btn-blue-primary" variant="outlined" size="medium">
                                                                                                    Go To Survey <ChevronRightIcon className="ChevronRightIcon" />
                                                                                                </Button>
                                                                                            </Link> :
                                                                                            <Button type="button" disabled={true} className="buttonDisabled" variant="outlined" size="medium">
                                                                                                Go To Survey <ChevronRightIcon className="ChevronRightIcon" />
                                                                                            </Button>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                                <div className="media-list clearfix">
                                                                    {
                                                                        data && data.is_Coverage_Applicable &&
                                                                        <CoverageComponent data={data && data.module_types && data.module_types.length > 0 && data.module_types.filter((x: { type: string; }) => x.type === 'Coverage')[0]} />
                                                                    }
                                                                    {
                                                                        data && data.is_Forecast_Applicable &&
                                                                        <ForecastComponent data={data && data.module_types && data.module_types.length > 0 && data.module_types.filter((x: { type: string; }) => x.type === 'Forecast')[0]} />
                                                                    }
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                    </Grid>
                                                    :
                                                    <div>
                                                        <h1 className="text-center "><b>Monitoring of  programmes for the {data && data.survey_name}  has been closed for the data collection activity.</b></h1>
                                                        <h1 className="text-center "><b>To view NutriDash Interactive Reports <Link to={`/surveyreports`} > Click here</Link></b></h1>
                                                    </div>

                                            }
                                        </div>
                                    </>
                                    :
                                    ''
                            }
                            <footer className="footerSection">
                                <div className="alignLeft">

                                    <p>
                                        Thanks for your time and contribution to NutriDash.
                                        Please use the links on the left to access NutriDash webinar series and other materials.
                                    If you have any questions and queries, feel free to contact us at <u>nutridash@unicef.org</u>.
                                                We may contact you regarding your submission if there is any clarification required. – NutriDash Team
                                        </p>

                                </div>
                                <div className="grow" />
                                {
                                    !this.state.isOfflineMode ?
                                        <div className="alignRight">

                                            <ul>
                                                <li>
                                                    <Typography>
                                                        <Link to={{ pathname: `/webinar` }} href="javascript(0)" className="pageLink">
                                                            <FeaturedVideoIcon className="footerIcon" /> Go to Webinars
                                                </Link>
                                                    </Typography>
                                                </li>
                                                <li>
                                                    <Typography>
                                                        <MatLink href="mailto:nutridash@unicef.org" className="pageLink">
                                                            <EmailIcon className="footerIcon" /> Contact Us
                                                        </MatLink>
                                                    </Typography>
                                                </li>
                                            </ul>
                                        </div>
                                        :
                                        ''
                                }

                            </footer>
                        </div>
                    </div>

                </ DataCollectorDashboardWrapper>

            </ ApplicationMain>
        );
    }
}


const mapStateToProps = (state: any) => {

    return {
        show: state.common.show,
        surveys: state.survey.surveys,
        pages: state.model.pages,
        data: state.userDashboard.userDashboard,
        countryData: state.model.countryData,
        syncOffline: state.model.syncOffline,
        isOfflineModeActivated: state.model.isOfflineModeActivated
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        getCountriesAssignedToUser: () => dispatch(getCountriesAssignedToUser()),
        dashboard: (countryId: any) => dispatch(userDashboard(countryId)),
        offlineDashboard: () => dispatch(userDashboardOffline()),
        syncOfflineResponse: (data: any) => dispatch(syncOfflineResponse(data)),
        showLoaderVisibility: () => dispatch(setLoaderVisibility(true)),
        hideLoaderVisibility: () => dispatch(setLoaderVisibility(false)),
        setSurveyOfflineMode: (data: any) => dispatch(setSurveyOfflineModeAction(data)),
        syncOfflineCompleted: () => dispatch(syncOfflineCompleted()),
        setSurveyResponseOffline: (data: any) => dispatch(setSurveyResponseOffline(data)),
        redirectTo: (path: string) => dispatch(push(path)),
        userRegionalAdminDashboard: (surveyId: any) => dispatch(userRegionalAdminDashboard(surveyId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DataCollectorResponseContainer);





// WEBPACK FOOTER //
// ./src/containers/DataCollectorResponseContainer.tsx